import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "../../../../../css/index.css";
import SectionGroup from "../SectionGroup/index.js";
import SectionItem from "../SectionItem/index.js";
const BrandsSection = () => {
  const items = [{
    children: 'The Bump',
    href: 'https://www.thebump.com'
  }, {
    children: 'The Bash',
    href: 'https://www.thebash.com'
  }, {
    children: 'Simply Eloped',
    href: 'https://simplyeloped.com'
  }];
  return /*#__PURE__*/React.createElement(SectionGroup, {
    title: "Sister Sites",
    trackableProps: {
      selection: 'sister-sites'
    },
    className: cx(styles.section, styles.brandsSection)
  }, _mapInstanceProperty(items).call(items, itemProps => /*#__PURE__*/React.createElement(SectionItem, _extends({
    key: itemProps.href
  }, itemProps))));
};
process.env.NODE_ENV !== "production" ? BrandsSection.propTypes = {
  tkHost: PropTypes.string
} : void 0;
export default BrandsSection;